import React, { useRef, useState } from 'react';
import { Event } from '@go-shared/types/event';
import { TextButton, Button, InlineIcon } from '@spark-labs/avocado-ui';

interface EventEditorProps {
  selectedEvent: Event;
  onClose: () => void;
}

const VARIABLES = [
  {
    label: 'Event Name',
    val: '{@EVENT_NAME}',
  },
  {
    label: 'Event Start Time',
    val: '{@EVENT_START_TIME}',
  },
  {
    label: 'Event End Time',
    val: '{@EVENT_END_TIME}',
  },
  {
    label: 'Event Name',
    val: '{@EVENT_NAME}',
  },
  {
    label: 'Event Name',
    val: '{@EVENT_NAME}',
  },
  {
    label: 'Event Name',
    val: '{@EVENT_NAME}',
  },
];
export const EventEditor: React.FC<EventEditorProps> = ({ selectedEvent, onClose }) => {
  const [value, setValue] = useState('');
  const ref = useRef<HTMLDivElement>(null);
  const updateText = () => {
    if (ref.current) {
      setValue(ref.current.innerHTML);
    }
  };

  const insertVariable = (variableValue: string) => {
    if (ref.current) {
      const text = document.createTextNode(` ${variableValue} `);
      ref.current.appendChild(text);
    }
  };
  return (
    <div className="px-3 pt-3 flex flex-col justify-between h-full">
      <span className="inline-flex justify-between">
        <h3>{selectedEvent.template.title}</h3>
        <TextButton onClick={onClose} className="border-none">
          <InlineIcon name="close" className="text-grey-dark" />
        </TextButton>
      </span>

      <div className="mt-4">
        <h4>Variables</h4>
        <div className="mt-2 inline-flex whitespace-no-wrap overflow-x-auto w-full">
          {VARIABLES.map(variable => {
            return (
              <span
                className="shadow-sm rounded-full bg-white px-3 py-1 border-grey-light 
                            border mr-2 cursor-pointer"
                onClick={() => insertVariable(variable.val)}
              >
                {variable.label}
              </span>
            );
          })}
        </div>
      </div>
      <div className="mt-4">
        <h4>Description</h4>
        <div className="relative mt-2 ">
          {!value && (
            <span className="absolute pointer-events-none text-grey-dark px-2 pt-3">
              Event Description
            </span>
          )}
          <div
            contentEditable
            onKeyUp={updateText}
            ref={ref}
            className="px-2 pt-3 min-h-32"
            style={{
              border: '1px solid rgba(0,0,0,.1)',
            }}
          ></div>
        </div>
      </div>

      <div className="mt-auto mb-3 ml-auto">
        <Button className="px-5 bg-blue-dark py-2 text-white">Save</Button>
      </div>
    </div>
  );
};
